export type NumberType = 'decimal' | 'percentage' | 'money';

export function formatNumber(value: number, type: NumberType, language: string, currency: string): string {
    if (type === 'decimal') {
        return numberValue(value, language);
    }

    if (type === 'money') {
        return moneyValue(value, language, currency);
    }

    return percentageValue(value);
}

function percentageValue(value: number): string {
    return value + '%';
}

function numberValue(value: number, language: string): string {
    return new Intl.NumberFormat(
        language,
        { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    ).format(value);
}

export function moneyValue(value: number, language: string, currency: string): string {
    return new Intl.NumberFormat(
        language,
        { style: 'currency', currency, maximumFractionDigits: 2, notation: 'compact' } as any,
    ).format(value);
}
